// @flow
import styled from 'styled-components'
import { oedu_green, oedu_red } from '../../styles/base'
import { Row, Col } from 'antd'

const rowMargin = `10px 0`

export const StyledCol = styled(Col)`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 400px;
  justify-content: center;
`

export const RowSymbol = styled(Row) `
  font-size: 35px;
  font-weight: 300;
  letter-spacing: 3px;
  margin: ${rowMargin};
`
export const RowPrice = styled(Row) `
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 2px;
  margin: ${rowMargin};
`

export const RowChange = styled(Row) `
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 1px;
  color: ${props => props.color > 0 ? oedu_green : oedu_red};
  margin: ${rowMargin}
`



// WEBPACK FOOTER //
// ./src/components/tab-company/style.js